import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { dispatch } from '../store';

const initialState = {
  id: null,
  name: '',
  card: '',
  has_card: false,
  delivery_addresses: [], // Array of delivery address objects
  gender: '',
  user: null,
  phone: '',
  address: '',
  note: '',
  sales: null,
  store: null,
  created_at: '',
  updated_at: '',
};

const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    setCustomer: (state, action) => {
      // Update customer details
      return action.payload;
    },
    updateField: (state, action) => {
      // Update a specific field (e.g., name, phone)
      const { field, value } = action.payload;
      state[field] = value;
    },
    addDeliveryAddress: (state, action) => {
      // Add a new delivery address
      state.delivery_addresses.push(action.payload);
    },
    updateDeliveryAddress: (state, action) => {
      // Update a specific delivery address by id
      const updatedAddresses = action.payload;

      state.delivery_addresses = updatedAddresses;
    },
    deleteDeliveryAddress: (state, action) => {
      const id = action.payload; // The ID of the delivery address to delete
      state.delivery_addresses = state.delivery_addresses.filter((address) => address.id !== id);
    },
    resetCustomer: () => initialState, // Reset customer state to initial
  },
});

export const {
  setCustomer,
  updateField,
  addDeliveryAddress,
  updateDeliveryAddress,
  deleteDeliveryAddress,
  resetCustomer,
} = customerSlice.actions;

export default customerSlice.reducer;

export const getCustomer = async () => {
  try {
    const url = `ecommerce/customer/`;
    const res = await axios.get(url);
    if (res.status === 200) {
      const data = res.data;
      dispatch(setCustomer(data));
    }
    return Promise.resolve();
  } catch (err) {
    return Promise.reject(err);
  }
};

export const handleAddNewAddress = async (address) => {
  try {
    const url = `ecommerce/customer/address/`;
    const res = await axios.post(url, { data: address });
    if (res.status === 201) {
      const data = res.data;
      dispatch(addDeliveryAddress(data));
    }
    return Promise.resolve();
  } catch (err) {
    return Promise.reject(err);
  }
};

export const handleEditAddress = async (address) => {
  try {
    const url = `ecommerce/customer/address/`;
    const res = await axios.put(url, { data: address });
    if (res.status === 200) {
      const data = res.data;
      dispatch(updateDeliveryAddress(data));
    }
    return Promise.resolve();
  } catch (err) {
    return Promise.reject(err);
  }
};
